import { getCurrentTraderAccount } from 'api/rest/traders/getCurrentTraderUser';
import { getDataAtom } from 'utils/atoms/dataAtom';
import { getDataFetchingAtom } from 'utils/atoms/dataFetchingAtom';

import { Trader } from '../models/Trader';

export const currentTraderAccountAtom = getDataAtom<Trader>();

export const fetchCurrentTraderAccountAtom = getDataFetchingAtom<
  Trader,
  undefined
>(currentTraderAccountAtom, getCurrentTraderAccount);
